import DynamicClass from './dynamicClass.ts';

export interface MAIN_CLASS_PARAMS {
	item: HTMLElement;
	callback: string | string[];
}

class MainClass {
	protected selector: HTMLElement;
	protected callback: string | string[];
	protected initAllCallBack: ( THIS: MainClass, selector: HTMLElement, functionName: string[] ) => void;
	protected initOneCallBack: (
		THIS: MainClass,
		selector: HTMLElement,
		functionName: string[],
		index: number,
	) => void;

	constructor( options: MAIN_CLASS_PARAMS ) {
		let { item, callback } = options;
		this.selector = item;
		this.callback = callback;
		this.initAllCallBack = function ( THIS, selector, functionName = [] ) {
			let callBacks = THIS.callback;
			if ( typeof callBacks === 'object' ) {
				callBacks.length > 0 &&
					callBacks.forEach( callback => {
						new DynamicClass( {
							className: callback,
							item: selector,
							callback: functionName,
						} );
					} );
			}
		};
		this.initOneCallBack = function ( THIS, selector, functionName = [], index = 0 ) {
			let callBacks = THIS.callback;
			if ( typeof callBacks === 'object' ) {
				callBacks.length > 0 &&
					new DynamicClass( {
						className: callBacks[ index ],
						item: selector,
						callback: functionName,
					} );
			}
		};
	}
}

export default MainClass;
